// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-blue-1 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #83c3fa !important;
  border-radius: 0.5rem !important;
  width: 12rem;
  margin-right: 3rem;
  border: 0 !important;
}

.card-blue-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #43a3fb !important;
  border-radius: 0.5rem !important;
  width: 12rem;
  margin-right: 3rem;
  border: 0 !important;
}

.card-blue-3 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #249bfa !important;
  border-radius: 0.5rem !important;
  width: 12rem;
  margin-right: 3rem;
  border: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminBoard/AdminBoard.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AACJ","sourcesContent":[".card-blue-1{\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    background-color: #83c3fa !important;\n    border-radius: 0.5rem !important;\n    width: 12rem;\n    margin-right: 3rem;\n    border: 0 !important;\n}\n\n.card-blue-2{\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    background-color: #43a3fb !important;\n    border-radius: 0.5rem !important;\n    width: 12rem;\n    margin-right: 3rem;\n    border: 0 !important;\n}\n\n.card-blue-3{\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    background-color: #249bfa !important;\n    border-radius: 0.5rem !important;\n    width: 12rem;\n    margin-right: 3rem;\n    border: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
